import * as React from 'react';

import {EnterprisePill} from '../acorn-pill/svg/enterprise';
import {Button} from '../button/button';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {FooterBar} from '../modal/footer-bar';
import {TwoPaneModal} from '../modal/two-pane-modal';
import {ModalBody} from '../typography/modal-body';
import {ModalHeader} from '../typography/modal-header';

import {SupportModalConfirmation} from './support-modal-confirmation';

import styles from './support-modal.module.css';

type Props = {
    headerText: string;
    headerSubtext: string;
    form: React.ReactElement<any>;
    onClose: () => void;
    onSubmit?: () => void;
    isSubmitDisabled?: boolean;
};

export function SupportModal(props: Props) {
    const [isShowingConfirmation, setIsShowingConfirmation] = React.useState<boolean>(false);

    const onSubmit = () => {
        if (props.onSubmit) {
            props.onSubmit();
            setIsShowingConfirmation(true);

            setTimeout(() => {
                props.onClose();
            }, 2000);
        }
    };

    const bodyComponent = (
        <div className={styles.container}>
            <EnterprisePill width={100} />
            <ModalHeader>{props.headerText}</ModalHeader>
            <StackLegacy spacing={16}>
                <div>
                    <ModalBody>{props.headerSubtext}</ModalBody>
                </div>
                {props.form}
            </StackLegacy>
            <div className={styles.footer}>
                <FooterBar
                    left={
                        <Button variant='text' size='big' onClick={props.onClose} noPadding={true}>
                            Cancel
                        </Button>
                    }
                    right={
                        props.onSubmit ? (
                            <Button
                                onClick={onSubmit}
                                disabled={props.isSubmitDisabled}
                                variant='primary'
                            >
                                Submit
                            </Button>
                        ) : undefined
                    }
                />
            </div>
        </div>
    );

    return (
        <>
            {isShowingConfirmation ? (
                <SupportModalConfirmation onClose={props.onClose} />
            ) : (
                <TwoPaneModal
                    // @ts-expect-error
                    isOpen={true}
                    minHeight={500}
                    onClose={props.onClose}
                    closeButton={false}
                    leftSection={
                        <div className={styles.left}>
                            <img
                                src='/include/images/support-team.png'
                                alt='Support team'
                                style={{width: '280px'}}
                            />
                        </div>
                    }
                    rightSection={bodyComponent}
                />
            )}
        </>
    );
}
